<template>
    <div class="fixed-footer" v-if="getTotalItems && !tiendaCerrada">
        <div class="footer-inner">
            <div class="footer-meta">
                <span class="footer-count">{{ getTotalItems }} productos</span>
                <span class="footer-total">${{ formattedTotal }}</span>
            </div>
            <v-btn
              class="footer-btn"
              color="primary"
              dark
              @click="verCarrito"
            >
              Ver carrito
            </v-btn>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { bus } from '@/helpers/bus.js'

export default {
  name: 'CarritoFooter',
  computed: {
    ...mapGetters('Carrito', ['getTotalItems', 'getSubtotal']),
    ...mapGetters('App', ['tiendaCerrada']),
    formattedTotal () {
      return (Number(this.getSubtotal) || 0).toLocaleString('es-AR')
    }
  },
  methods: {
    verCarrito () {
      bus.$emit('ver-carrito')
    }
  }
}
</script>
<style scoped>
.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px));
  z-index: 100;
  background: #fff;
  border-top: 1px solid #ececec;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
}
.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 560px;
  margin: 0 auto;
}
.footer-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.footer-count {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.55);
}
.footer-total {
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.2;
}
.footer-btn {
  min-width: 140px;
  height: 44px !important;
  border-radius: 12px !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  font-weight: 700 !important;
  color: #fff !important;
}
</style>
